import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormatService {

  constructor() { }

  formatText(value: string | number): string | number {
    function isValidDate(date: string): boolean {
      // Check if the string matches common date formats (YYYY-MM-DD, MM/DD/YYYY, or ISO format)
      if (typeof date !== 'string') return false;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) &&
          !/^\d{2}\/\d{2}\/\d{4}$/.test(date) &&
          !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(date)) {
        return false;
      }
      return !isNaN(new Date(date).getTime());
    }

    function stripHtmlTags(str: string): string {
      return str.replace(/<\/?[^>]+(>|$)/g, '').trim();
    }

    // Check for ISO or standard date formats
    if (typeof value === 'string' && isValidDate(value)) {
      const date = new Date(value);
      return new Intl.DateTimeFormat('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
      }).format(date);
    }

    // Check for email pattern
    if (typeof value === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return value.trim();
    }

    // Strip HTML tags and replace new lines with `<br>`
    if (typeof value === 'string') {
      const cleanedValue = stripHtmlTags(value);
      return cleanedValue.replace(/\n/g, '<br>');
    }

    // Check for currency/amount (number with decimals)
    if (typeof value === 'number') {
      if (value % 1 !== 0) {
        return value.toFixed(2);
      }
      return value;
    }

    return value;
  }
}
